import React, { useRef, useState } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './Layout.scss';
import { Outlet } from 'react-router-dom';

const Layout = () => {
	const [collapsed, setCollapsed] = useState(false);
	const inputRef = useRef(null);

	return (
		<div>
			<div>
				<Navbar
					collapsed={collapsed}
					inputRef={inputRef}
					setCollapsed={setCollapsed}
				/>
				<div className="d-flex">
					<Sidebar
						inputRef={inputRef}
						collapsed={collapsed}
						setCollapsed={setCollapsed}
					/>
					<div className="layout-wrapper">
						<Outlet />
					</div>
				</div>
			</div>
		</div>
	);
};
export default Layout;
